import agent from './agent';
import {
    ASYNC_START,
    ASYNC_END,
    LOGOUT, SUBMIT_AUTH_CODE, SET_USER_ID
} from './actions/actionsTypes';

const promiseMiddleware = store => next => action => {
    if (isPromise(action.payload)) {
        store.dispatch({ type: ASYNC_START, subtype: action.type });

        const currentView = store.getState().viewChangeCounter;
        const skipTracking = action.skipTracking;

        action.payload.then(
            res => {
                const currentState = store.getState();
                if (!skipTracking && currentState.viewChangeCounter !== currentView) {
                    return;
                }
                // console.log('RESULT', res);
                action.payload = res;
                store.dispatch({ type: ASYNC_END, promise: action.payload });
                store.dispatch(action);
            },
            error => {
                const currentState = store.getState();
                if (!skipTracking && currentState.viewChangeCounter !== currentView) {
                    return
                }
                console.log('ERROR', error);
                action.error = true;
                action.payload = error.response;
                if (!action.skipTracking) {
                    store.dispatch({ type: ASYNC_END, promise: action.payload });
                }
                store.dispatch(action);
            }
        ).catch(error =>{
            console.log('error:', error)
        })
        .finally(()=>{
            store.dispatch({ type: ASYNC_END})
        })

        return;
    }
    // else if (){
    //     store.dispatch({type:LOGOUT});
    // }

    next(action);
};

const localStorageMiddleware = store => next => action => {
    if (action.type === SUBMIT_AUTH_CODE) {
        if (!action.error && action.data) {

            window.localStorage.setItem('jwt', action.data.token);
            window.localStorage.setItem('user_id', action.data.user_id);
            store.dispatch({type: SET_USER_ID, value: action.data.user_id});
            agent.setToken(action.data.token);
        }
    } else if (action.type === LOGOUT) {
        window.localStorage.setItem('jwt', '');
        window.localStorage.setItem('user_id', '');
        agent.setToken(null);
    }

    // console.log(action.payload, agent.token);

    next(action);
};

function isPromise(v) {
    return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware }
